import { CoreModule } from '@abp/ng.core';
import { ThemeSharedModule } from '@abp/ng.theme.shared';
import { NgModule } from '@angular/core';
import { NgbCollapseModule, NgbDatepickerModule, NgbDropdownModule } from '@ng-bootstrap/ng-bootstrap';
import { NgxValidateCoreModule } from '@ngx-validate/core';
import { CommercialUiModule } from '@volo/abp.commercial.ng.ui';
import { AssetComponent } from './components/asset.component';
import { AssetRoutingModule } from './asset-routing.module';
import { AssetEventModule } from '../../asset-events/asset-event/asset-event.module';
import { AssetDetailsComponent } from './components/asset-details/asset-details.component';
import { SearchAssetModalComponent } from './components/search-asset-modal/search-asset-modal.component';

import { PerfectScrollbarModule } from 'ngx-perfect-scrollbar';
import { PERFECT_SCROLLBAR_CONFIG } from 'ngx-perfect-scrollbar';
import { PerfectScrollbarConfigInterface } from 'ngx-perfect-scrollbar';

const DEFAULT_PERFECT_SCROLLBAR_CONFIG: PerfectScrollbarConfigInterface = {
  suppressScrollX: true
};

@NgModule({
  declarations: [AssetComponent, AssetDetailsComponent, SearchAssetModalComponent],
  imports: [
    AssetRoutingModule,
    CoreModule,
    ThemeSharedModule,
    CommercialUiModule,
    NgxValidateCoreModule,
    NgbCollapseModule,
    NgbDatepickerModule,
    NgbDropdownModule,
    AssetEventModule,
    PerfectScrollbarModule
  ],
  exports: [ AssetComponent ],
  providers: [
    {
      provide: PERFECT_SCROLLBAR_CONFIG,
      useValue: DEFAULT_PERFECT_SCROLLBAR_CONFIG
    }
  ]
})
export class AssetModule {}

export function loadAssetModuleAsChild() {
  return Promise.resolve(AssetModule);
}
